import {
  AppCard,
  AppCardActions,
  AppCardContent,
  AppCardMedia,
} from '@app/components/base/app-card';
import { Box, Grid, Skeleton } from '@mui/material';

/**
 * Placeholder card matching {@link EditCard} layout (16:9 media, title, action row) for loading states.
 * Media region uses a ratio wrapper so the skeleton fill respects 16:9 (rectangular Skeleton overrides height on the root).
 */
export function EditCardSkeleton() {
  return (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
      <AppCard
        interactive={false}
        media={
          <AppCardMedia>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                aspectRatio: '16/9',
              }}
            >
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  transform: 'none',
                }}
              />
            </Box>
          </AppCardMedia>
        }
      >
        <AppCardContent sx={{ pb: 0 }}>
          <Skeleton variant="text" animation="wave" width="75%" sx={{ typography: 'subtitle1' }} />
        </AppCardContent>
        <AppCardActions>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Skeleton variant="rounded" animation="wave" width={100} height={32} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Skeleton variant="circular" animation="wave" width={32} height={32} />
            <Skeleton variant="circular" animation="wave" width={32} height={32} />
          </Box>
        </AppCardActions>
      </AppCard>
    </Grid>
  );
}
